module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestfold_telemark_neg.30b79b87.png";